/* src/app/subcontractor/partials/subcontractor-depot-from/subcontractor-depot-from.component.scss */
/*# sourceMappingURL=subcontractor-depot-from.component.css.map */
